import { bankRoutes } from "modules/banks";

import type { Route } from "../RouteModel";

export const administrationRoutes: Route = {
  i18nName: "Administration",
  showChildrenInSidebar: true,
  icon: undefined,
  path: "/administration",
  children: [bankRoutes],
};
